import { render, staticRenderFns } from "./LsvaTrailersView.vue?vue&type=template&id=0596e5c8&scoped=true&"
import script from "./LsvaTrailersView.vue?vue&type=script&lang=js&"
export * from "./LsvaTrailersView.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTrailersView.vue?vue&type=style&index=0&id=0596e5c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596e5c8",
  null
  
)

/* custom blocks */
import block0 from "./LsvaTrailersView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports